import React from "react";
import CrosswordHowTo from "./CrosswordHowTo";

/** Route entry: `/howto/puzzle/crossword` */
export default function HowToCrossword() {
    return <CrosswordHowTo />;
}
